<template>
  <div class="churn-calculation-settings">
    <header class="header">
      <div class="back-button" @click="onClickBack">
        <span>{{ '< Back' }}</span>
      </div>
      <div class="divider" />
      <div class="info">
        <div class="row">
          <span>แหล่งที่มาที่:</span>
          <span>All Customer</span>
        </div>
        <div class="row">
          <span>ระยะการคำนวณ:</span>
          <div v-if="true"><RiskChurnFaceIcon /><span>Risk Churn</span></div>
          <div v-else><ChurnedFaceIcon /><span>Risk Churn</span></div>
        </div>
        <div class="row">
          <span>Last Update:</span>
          <span>23/04/67 13:29</span>
        </div>
        <div class="row">
          <span>Last Update by:</span>
          <span>Cameron Williamson</span>
        </div>
      </div>
      <div class="divider" />
      <div class="actions">
        <button class="btn btn-outline-secondary cancel-button" @click="onClickCancel">ยกเลิก</button>
        <button class="btn btn-primary apply-button" @click="onClickApply">นำไปใช้</button>
      </div>
    </header>

    <section class="settings-section">
      <div style="background: #fff; margin-top: 1rem; border-radius: 10px; padding: 24px; box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.1)">
        <h2>กำหนดรูปแบบการคำนวณอัตราการเลิกเป็นลูกค้า</h2>
        <h3>กรุณาเลือกโหมดการคำนวณอัตราการเลิกเป็นลูกค้า</h3>
        <div class="dividerx" />
        <div class="toggle-group">
          <div class="toggle-radio-type-container">
            <label>
              <input type="radio" name="calculationType" value="simple" v-model="calculationType" />
              <span>โหมดการคำนวณอิงเงื่อนไขแบบง่าย</span>
            </label>
            <div class="tooltip-question">
              <CommentBox class="title-question-icon" />
              <span class="tooltip-text">
                <div class="title">{{ 'โหมดการคำนวณอิงเงื่อนไขแบบง่าย' }}</div>
              </span>
            </div>
          </div>
          <div class="toggle-radio-type-container">
            <label>
              <input type="radio" name="calculationType" value="advance" v-model="calculationType" :disabled="true" />
              <span>โหมดการคำนวณอิงเงื่อนไขแบบขั้นสูง</span>
            </label>
            <div class="tooltip-question">
              <CommentBox class="title-question-icon" />
              <span class="tooltip-text">
                <div class="title">{{ 'โหมดการคำนวณอิงเงื่อนไขแบบขั้นสูง' }}</div>
              </span>
            </div>
          </div>
        </div>
      </div>

      <div v-if="calculationType == 'simple'" class="body-content-container"><CalSimpleMode /></div>
      <div v-else class="body-content-container"><CalAdvanceMode /></div>
    </section>
  </div>
</template>

<script setup lang="ts">
import { onBeforeMount, ref, Ref, markRaw } from 'vue';
import router from '@/router';
import CalAdvanceMode from '@/views/modules/analytics/components/anal-churnrate/CalAdvanceMode.vue';
import CalSimpleMode from '@/views/modules/analytics/components/anal-churnrate/CalSimpleMode.vue';
import RiskChurnFaceIcon from '@/assets/icons/modules/analytics/churn-rate/RiskChurnFaceIcon.vue';
import ChurnedFaceIcon from '@/assets/icons/modules/analytics/churn-rate/ChurnedFaceIcon.vue';
import CommentBox from '@/assets/icons/modules/segment/all-segment/CommentBox.vue';
import useValidationModal from '@/views/components/modal/hooks/useValidationModal';

const { openDefaultErrorModal, openWarningModal, openSuccessModal, openErrorModal } = useValidationModal();

const calculationType = ref<string>('simple');
function goBack() {
  router.push({
    path: '/analytics/churnRate/calculate',
    query: {
      ...router.currentRoute.value.query,
    },
  });
}
function onClickBack() {
  openWarningModal('ข้อมูลที่ตั้งค่าใหม่จะถูกยกเลิก', `ต้องการยืนยันการกลับ ใช่หรือไม่ ?`, () => goBack());
}
function onClickCancel() {
  openWarningModal('ต้องการยกเลิกตั้งค่าใหม่', `ต้องการยกเลิก ใช่หรือไม่ ?`, () => goBack());
}
function onClickApply() {
  openSuccessModal('ทำรายการสำเร็จ', '', '', undefined, () => goBack());
}
</script>

<style lang="scss" scoped>
.title-question-icon {
  padding-left: 0.5rem;
  width: 25px;
  height: auto;
  fill: #707070;
  &:hover {
    fill: #000000;
  }
}
.tooltip-question {
  position: relative;
  display: inline-block;

  &:hover {
    .tooltip-text {
      visibility: visible;
    }
  }

  .tooltip-text {
    position: relative;
    visibility: hidden;
    background-color: #efefef;
    text-align: center;
    border-radius: 6px;
    padding: 1rem;
    max-width: 370px;
    width: max-content;

    /* Position the tooltip */
    position: absolute;
    z-index: 1;
    top: -5px;
    left: 40px;
    font-weight: 400;
    text-align: left;
    .title {
      color: #000000;
    }
    .detail {
      color: #707070;
    }

    &::after {
      content: '';
      position: absolute;
      left: -9px;
      top: 10px;
      width: 0px;
      height: 0px;

      border-right: 10px solid #efefef;
      border-bottom: 5px solid transparent;
      border-top: 5px solid transparent;
    }
  }
}
.churn-calculation-settings {
  padding: 16px;

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 96px;
    padding: 16px;
    gap: 20px;
    border-radius: 10px;
    background: #ffffff;
    box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.1);

    .back-button {
      margin-left: 1rem;
      //styleName: H2;
      font-family: Prompt;
      font-size: 16px;
      font-weight: 500;
      line-height: 1;
      text-wrap: nowrap;
      text-align: left;
      cursor: pointer;
      span {
        margin-left: 1rem;
      }
    }

    .info {
      display: flex;
      width: 60%;
      .row {
        display: flex;
        align-items: center;
        align-content: space-between;
        //styleName: SH1;
        font-family: Prompt;
        font-size: 16px;
        font-weight: 700;
        line-height: 24.19px;
        text-align: left;
        color: #646464;
        svg {
          width: 20px;
          height: 20px;
          margin-right: 0.5rem;
        }
        span:nth-child(2) {
          //styleName: Text Med 16;
          font-family: Prompt;
          font-size: 16px;
          font-weight: 400;
          line-height: 24.19px;
          text-align: left;
          color: #373737;
          margin-top: 0.5rem;
        }
      }
    }

    .actions {
      display: flex;
      gap: 16px;

      .cancel-button,
      .apply-button {
        min-width: 100px;
        min-height: 45px;
        padding: 8px 16px;
        border-radius: 8px;
        cursor: pointer;
      }
    }
  }

  .divider {
    margin-left: 1rem;
    margin-right: 1rem;
    width: 1px;
    height: 100%;
    background: #e2e2e2;
  }
  .dividerx {
    margin-top: 2rem;
    margin-bottom: 2rem;
    width: 100%;
    height: 1px;
    background: #e2e2e2;
  }

  .settings-section {
    margin-top: 1rem;
    width: 100%;
    gap: 24px;
    .body-content-container {
      border-radius: 10px;
      box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.1);
    }
    h2 {
      //styleName: H2;
      font-family: Prompt;
      font-size: 20px;
      font-weight: 500;
      line-height: 30.24px;
      text-align: left;
    }
    h3 {
      margin-top: 1rem;

      //styleName: SH1;
      font-family: Prompt;
      font-size: 16px;
      font-weight: 400;
      line-height: 24.19px;
      text-align: left;
      color: #606a6c;
    }
    .toggle-group {
      display: flex;
      gap: 220px;
      span {
        margin-right: 1rem;
      }
      label {
        display: flex;
        align-items: center;
        cursor: pointer;
        //styleName: Text Med 16;
        font-family: Prompt;
        font-size: 16px;
        font-weight: 500;
        line-height: 24.19px;
        text-align: left;

        input[type='radio'] {
          width: 15px;
          height: 15px;
          &:checked {
            accent-color: #61a358;
          }
        }

        input {
          margin-right: 8px;
        }
      }
      .toggle-radio-type-container {
        display: flex;
      }
    }
  }
}
</style>
